import { jsx as _jsx } from "react/jsx-runtime";
import { List } from '@coveord/plasma-mantine';
import { PromptListItem } from './PromptListItem.js';
import classes from './PromptList.module.css';
export var PromptList = function PromptList(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(List, {
        size: "sm",
        pr: "lg",
        classNames: classes,
        children: children
    });
};
PromptList.Item = PromptListItem;
PromptList.displayName = '@components/mantine/PromptList';

//# sourceMappingURL=PromptList.js.map